import { Component, OnInit, ViewChild, NgZone, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

// Thrid Library
import { BsModalComponent } from 'ng2-bs3-modal';
import {NgProgressService} from "ng2-progressbar";

//Service
import { DataChangedEvent } from '../service/datachangedevent';
import { HttpServices } from '../service/httpservices';

//Model
import { Department } from './department';

@Component({
    selector: 'i-department',
    templateUrl: './department.component.html'
})

export class DepartmentCP implements OnInit {
    @ViewChild('modal', { static: false }) modal: BsModalComponent;
    @ViewChild('entryModal', { static: false }) entryModal: BsModalComponent;
    @ViewChild('deleteModal', { static: false }) deleteModal: BsModalComponent;
    @ViewChild('serviceModal', { static: false }) serviceModal: BsModalComponent;
    @ViewChild('input', { static: false }) vc;
    @Input() isModal: boolean = false;

    apiName: string = "department";
    id = 'DID';
    public dptForm: FormGroup;
    public isNew: boolean;
    public departmentList: Department[];
    public selectedDepartment: Department;
    public selectedChk: Department[];
    public actionlogs: any[];
    public toastkey = "i-department";

    public totalRecords: number;
    //@ViewChild(NgProgressComponent) pService: NgProgressComponent;
    constructor(private pService: NgProgressService ,public httpService: HttpServices, public fb: FormBuilder, public _dataChanged: DataChangedEvent, public _ngZone: NgZone) {
        this.pService.start();
        this._dataChanged.departmentChanged.subscribe((sRobj) => {
            //this.LoadDataFromLocalForage();

            if (sRobj && sRobj.ObjType) {
                this._ngZone.run(() => {
                    if (sRobj.ObjType.toLowerCase() === this.apiName.toLowerCase()) {
                        this.afterBroadCastEvent(sRobj);
                    }
                });
            }
        });
    }

    ngOnInit() {
        this.CreateForm();
        this.GetData();
    }

    CreateForm(): void {
        this.dptForm = this.fb.group({
            'DID': new FormControl(0),
            'DN': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(50)]))
        });
    }

    GetData() {
        let depList: Department[] = [];
        this.httpService.getData('api/department').subscribe(
            data => {
                depList = data;
            },
            err => {
                this.httpService.showToast(this.toastkey, 'error', 'Error occurs while loading data from server!');
                this.pService.done();
            },
            () => {
                this.departmentList = depList.map(a => Object.assign({}, a));
                this.totalRecords = this.departmentList.length;

                this.pService.done();
            }
        );
    }

    afterBroadCastEvent(objData) {
        if (objData && objData.Obj) {
            let ind = this.departmentList.findIndex(temp => temp[this.id] === objData.Obj[this.id]);
            if (objData.Msg === 'deleted') {
                this.refresh();
            }
            else {
                if (ind >= 0) this.departmentList[ind] = objData.Obj;
                else this.departmentList.unshift(objData.Obj);
            }
        }
    }

    refresh() {
        this.pService.start();
        this.GetData();
    }

    showDialogToAdd(): void {
        this.isNew = true;
        this.CreateForm();
        this.entryModal.open();
        this.vc.nativeElement.focus();
    }

    showDialogToEdit(department: Department): void {
        this.isNew = false;
        this.CreateForm();
        this.selectedDepartment = Object.assign({}, department);
        this.dptForm.patchValue({ DID: department.DID, DN: department.DN });
        this.entryModal.open();
        this.vc.nativeElement.focus();
    }

    showDialogToDelete(): void {
        if (this.selectedChk != null && this.selectedChk != undefined && this.selectedChk.length > 0) { this.deleteModal.open(); }
        else { this.httpService.showToast(this.toastkey, 'warn', 'Need to select row!'); }
    }

    showLogDialog(): void {
        if (this.selectedDepartment != undefined) {
            let temp = [];
            this.pService.start();
            this.httpService.getData('api/actionlog/' + this.selectedDepartment.DID + '/' + 'Department').subscribe(
                data => temp = data,
                err => {
                    this.httpService.showToast(this.toastkey, 'error', 'Error occurs while loading data from server!');
                    this.pService.done();
                },
                () => {
                    if (temp != undefined) { this.actionlogs = temp; this.modal.open(); }
                    else { this.httpService.showToast(this.toastkey, 'warn', 'There is no record to show!'); }
                    this.pService.done();
                });
        }
    }

    entryModalClose() {
        this.entryModal.close();
        this.httpService.AddClassToModal(this.isModal);
    }

    save(pdt: any, gb): void {
        if (this.dptForm != undefined) {
            this.pService.start();
            this.httpService.postData('api/department', this.dptForm.value).
                subscribe(
                    ddd => { },
                    err => {
                        this.httpService.showToast(this.toastkey, 'error', 'Error occurs while inserting/updating data!');
                        this.pService.done();
                    },
                    () => {
                        this.resetDatable(pdt, gb);
                        this.GetData();
                        this.httpService.showToast(this.toastkey, 'success', 'Successfully inserted/updated!');
                        this.entryModal.close();
                        this.pService.done();
                        this.httpService.AddClassToModal(this.isModal);
                    });
        }
    }

    deleteData(): void {
        this.httpService.postData('api/department/multidelete/', this.selectedChk).
            subscribe(
                data => {
                    this.httpService.showUnsuccessDelMsg(this.toastkey, data);
                },
                err => {
                    this.doneDeleteProcess('error', 'Error occurs while deleting data!');
                },
                () => {
                    this.doneDeleteProcess('success', 'Successfully deleted');
                });
    }

    deleteModalClose() {
        this.deleteModal.close();
        this.httpService.AddClassToModal(this.isModal);
    }


    doneDeleteProcess(header: string, msg: string) {
        this.selectedChk = null;
        this.deleteModalClose();
        this.httpService.showToast(this.toastkey, header, msg);
    }

    resetDatable(pdt: any, gb): void {
        if (gb && gb.value && gb.value != '') {
            gb.value = '';
            if (pdt) pdt.reset();
        }
    }

    modalClose() {
        this.modal.close();
        this.httpService.AddClassToModal(true);
    }

    exportToCSV() {
        this.httpService.postData('api/department/export', null).subscribe(
            data => { },
            err => { },
            () => {
                //window.location.href = this.httpService._url + 'excel/department.csv';
                this.httpService.DirectLocToWindow("department");
            }
        );
    }
}